/* KETTLER — PDP Zone 4: Auf- und Zuklappen der häufigen Fragen. */
(function () {
  'use strict';
  function start() {
    document.querySelectorAll('[data-kettler-zone="beweis"] .k-faqbtn').forEach(function (btn) {
      if (btn.dataset.gebunden) return;
      btn.dataset.gebunden = '1';
      btn.addEventListener('click', function () {
        var ziel = document.getElementById(btn.getAttribute('aria-controls'));
        var offen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!offen));
        if (ziel) ziel.style.display = offen ? 'none' : 'block';
        var pfeil = btn.querySelector('.k-faqpfeil');
        if (pfeil) pfeil.style.transform = 'rotate(' + (offen ? 0 : 180) + 'deg)';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
